;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useRouter } from 'next/router'
import { useUserContext } from 'src/deprecated/contexts/User'

const exemptPaths = ['/login', '/legal/terms', '/activate-account']

export const useSlaEnforcement = () => {
  const user = useUserContext()
  const router = useRouter()

  const requiresSlaAcceptance = Boolean(user && !user.sellerAcceptedSlaAt)

  const shouldEnforceSla =
    requiresSlaAcceptance &&
    !user?.isQogitaUser &&
    !exemptPaths.some((exemptPath) => router.asPath.startsWith(exemptPath))

  return {
    requiresSlaAcceptance,
    shouldEnforceSla,
  }
}
